import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  showSignInCta: false
} satisfies RecursivePartial<DialogConfig['signUp']>
